import { render, staticRenderFns } from "./tenderLotsCount.vue?vue&type=template&id=08f5cd74"
import script from "./tenderLotsCount.vue?vue&type=script&lang=js"
export * from "./tenderLotsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports